module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABFCAYAAADU4cH/AAAAAXNSR0IArs4c6QAAAVxJREFUeAHt3MFNw0AQBVAbcaMYWgDRBgVwoIjQBcdcSB2kjnCAIrghmRmRnBIjiEYoyz5LiaJ1PJ599unL3mGwlQqM0zQtSiu2UWyKNl/isxrHMX+XbQlaWrCss78pdBugT5WnOqssptYwnAfCQ6cQm5j3qtO5mzYBAgQIECBAgAABAgQIECCwFcj47plGnUDveWid5LaSPLSYNPPQ6+KayhEgQIAAAQIECBAgQIAAAQIEmhEQ3/3uUr3H3+/jEcjl3GHiuzmZw+MXMXx3eNfXKNDvdPb35R36uD9shAABAgQIECBAgAABAgQIEGhVIOO7q1abP6G+843u14j13uShdVflI0rdiO/qQPNJxsv8WtfV7LbSboWIZbcCJk6AAAECBAgQIECAAAECBBoVyPhu0WjvP2l7F1qUL2s5d/Je8tDyZS3nQOWhczJHjmce+t+Xu7Ss5ZE3x0kc9gnARjrOBqWf/AAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/video-player/transcript-icon.png
 ** module id = 347
 ** module chunks = 0
 **/